import * as actionTypes from '../../../constants/ActionTypes/CSAgentPortal/CustomerDashboard';

const initialState = {
    customer_data: {},
    loading: false,
    error: null,
}

const CustomerDashboardInfo = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CUSTOMER_INFO_CALL_INIT:
            return {
                ...state,
                loading: true
            }
        
        case actionTypes.CUSTOMER_INFO_CALL_SUCCESS:
            return {
                ...state,
                customer_data: action.customerData,
                loading: false,
                error: null
            }
        
        case actionTypes.CUSTOMER_INFO_CALL_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                customer_data: {}
            }
        case actionTypes.RESET_STATE:
            return { ...state, 
                loading: false,
                error:null,
                customer_data: {}
              };
        default:
            return {...state}
    }
}

export default CustomerDashboardInfo